
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _healthcheckqHFF6kBCjFMeta } from "/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue?macro=true";
import { default as booking_45confirmation_45errorYB0JdhOOKfMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue?macro=true";
import { default as booking_45confirmationOCA1o1TNWaMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue?macro=true";
import { default as booking_45retryBuUCmPzNNqMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue?macro=true";
import { default as rate2uxmxXTHzkMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue?macro=true";
import { default as room2JY6OMXl6FMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue?macro=true";
import { default as _91ridcode_934c03WsBBnfMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue?macro=true";
import { default as details8pzARj1ZhaMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue?macro=true";
import { default as paymentb2y0qclCPQMeta } from "/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue?macro=true";
import { default as bookingsN6uvVOyv2Meta } from "/usr/src/app/packages/all-inclusive-app/pages/booking.vue?macro=true";
import { default as continue_45booking3hrzmMu35mMeta } from "/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue?macro=true";
import { default as debugAuthddjNks9lsUMeta } from "/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue?macro=true";
import { default as indexY4QFcRAMwqMeta } from "/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue?macro=true";
import { default as _91offerSlug_93K9kdhYcjVqMeta } from "/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue?macro=true";
import { default as indexSYQeRCDx2TMeta } from "/usr/src/app/packages/all-inclusive-app/pages/index.vue?macro=true";
import { default as _91slug_93IAASyQZ68gMeta } from "/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue?macro=true";
import { default as maintenance8PnTKBquPDMeta } from "/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue?macro=true";
import { default as _91slug_935yhvTgs9KDMeta } from "/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue?macro=true";
import { default as searchkZZbnzUBeCMeta } from "/usr/src/app/packages/all-inclusive-app/pages/search.vue?macro=true";
export default [
  {
    name: "_healthcheck___en___default",
    path: "/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___en",
    path: "/en/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___ru",
    path: "/ru/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___tr",
    path: "/tr/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___de",
    path: "/de/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___fr",
    path: "/fr/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___es",
    path: "/es/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___xx",
    path: "/xx/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___ar",
    path: "/ar/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___zh",
    path: "/zh/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___ta",
    path: "/ta/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___vi",
    path: "/vi/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___kk",
    path: "/kk/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___it",
    path: "/it/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___nl",
    path: "/nl/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___he",
    path: "/he/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___ko",
    path: "/ko/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___pt",
    path: "/pt/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___th",
    path: "/th/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___uk",
    path: "/uk/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___pl",
    path: "/pl/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___ro",
    path: "/ro/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "_healthcheck___hi",
    path: "/hi/_healthcheck/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/_healthcheck.vue")
  },
  {
    name: "booking-confirmation-error___en___default",
    path: "/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___en",
    path: "/en/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___ru",
    path: "/ru/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___tr",
    path: "/tr/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___de",
    path: "/de/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___fr",
    path: "/fr/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___es",
    path: "/es/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___xx",
    path: "/xx/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___ar",
    path: "/ar/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___zh",
    path: "/zh/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___ta",
    path: "/ta/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___vi",
    path: "/vi/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___kk",
    path: "/kk/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___it",
    path: "/it/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___nl",
    path: "/nl/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___he",
    path: "/he/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___ko",
    path: "/ko/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___pt",
    path: "/pt/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___th",
    path: "/th/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___uk",
    path: "/uk/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___pl",
    path: "/pl/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___ro",
    path: "/ro/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation-error___hi",
    path: "/hi/booking-confirmation-error/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation-error.vue")
  },
  {
    name: "booking-confirmation___en___default",
    path: "/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___en",
    path: "/en/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___ru",
    path: "/ru/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___tr",
    path: "/tr/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___de",
    path: "/de/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___fr",
    path: "/fr/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___es",
    path: "/es/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___xx",
    path: "/xx/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___ar",
    path: "/ar/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___zh",
    path: "/zh/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___ta",
    path: "/ta/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___vi",
    path: "/vi/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___kk",
    path: "/kk/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___it",
    path: "/it/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___nl",
    path: "/nl/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___he",
    path: "/he/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___ko",
    path: "/ko/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___pt",
    path: "/pt/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___th",
    path: "/th/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___uk",
    path: "/uk/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___pl",
    path: "/pl/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___ro",
    path: "/ro/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-confirmation___hi",
    path: "/hi/booking-confirmation/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-confirmation.vue")
  },
  {
    name: "booking-retry___en___default",
    path: "/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___en",
    path: "/en/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___ru",
    path: "/ru/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___tr",
    path: "/tr/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___de",
    path: "/de/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___fr",
    path: "/fr/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___es",
    path: "/es/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___xx",
    path: "/xx/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___ar",
    path: "/ar/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___zh",
    path: "/zh/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___ta",
    path: "/ta/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___vi",
    path: "/vi/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___kk",
    path: "/kk/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___it",
    path: "/it/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___nl",
    path: "/nl/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___he",
    path: "/he/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___ko",
    path: "/ko/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___pt",
    path: "/pt/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___th",
    path: "/th/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___uk",
    path: "/uk/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___pl",
    path: "/pl/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___ro",
    path: "/ro/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking-retry___hi",
    path: "/hi/booking-retry/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking-retry.vue")
  },
  {
    name: "booking___en___default",
    path: "/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___en___default",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___en___default",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___en___default",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___en___default",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___en___default",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___en",
    path: "/en/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___en",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___en",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___en",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___en",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___en",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___ru",
    path: "/ru/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___ru",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___ru",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___ru",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___ru",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___ru",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___tr",
    path: "/tr/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___tr",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___tr",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___tr",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___tr",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___tr",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___de",
    path: "/de/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___de",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___de",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___de",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___de",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___de",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___fr",
    path: "/fr/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___fr",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___fr",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___fr",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___fr",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___fr",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___es",
    path: "/es/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___es",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___es",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___es",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___es",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___es",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___xx",
    path: "/xx/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___xx",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___xx",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___xx",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___xx",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___xx",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___ar",
    path: "/ar/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___ar",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___ar",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___ar",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___ar",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___ar",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___zh",
    path: "/zh/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___zh",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___zh",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___zh",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___zh",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___zh",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___ta",
    path: "/ta/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___ta",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___ta",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___ta",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___ta",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___ta",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___vi",
    path: "/vi/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___vi",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___vi",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___vi",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___vi",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___vi",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___kk",
    path: "/kk/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___kk",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___kk",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___kk",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___kk",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___kk",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___it",
    path: "/it/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___it",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___it",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___it",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___it",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___it",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___nl",
    path: "/nl/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___nl",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___nl",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___nl",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___nl",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___nl",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___he",
    path: "/he/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___he",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___he",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___he",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___he",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___he",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___ko",
    path: "/ko/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___ko",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___ko",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___ko",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___ko",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___ko",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___pt",
    path: "/pt/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___pt",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___pt",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___pt",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___pt",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___pt",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___th",
    path: "/th/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___th",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___th",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___th",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___th",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___th",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___uk",
    path: "/uk/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___uk",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___uk",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___uk",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___uk",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___uk",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___pl",
    path: "/pl/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___pl",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___pl",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___pl",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___pl",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___pl",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___ro",
    path: "/ro/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___ro",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___ro",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___ro",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___ro",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___ro",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "booking___hi",
    path: "/hi/booking/",
    meta: bookingsN6uvVOyv2Meta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking.vue"),
    children: [
  {
    name: "booking-ridcode___hi",
    path: ":ridcode()/",
    meta: _91ridcode_934c03WsBBnfMeta || {},
    redirect: _91ridcode_934c03WsBBnfMeta?.redirect,
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode].vue"),
    children: [
  {
    name: "booking-ridcode-rate___hi",
    path: "rate/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/rate.vue")
  },
  {
    name: "booking-ridcode-room___hi",
    path: "room/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/[ridcode]/room.vue")
  }
]
  },
  {
    name: "booking-details___hi",
    path: "details/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/details.vue")
  },
  {
    name: "booking-payment___hi",
    path: "payment/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/booking/payment.vue")
  }
]
  },
  {
    name: "continue-booking___en___default",
    path: "/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___en",
    path: "/en/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___ru",
    path: "/ru/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___tr",
    path: "/tr/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___de",
    path: "/de/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___fr",
    path: "/fr/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___es",
    path: "/es/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___xx",
    path: "/xx/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___ar",
    path: "/ar/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___zh",
    path: "/zh/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___ta",
    path: "/ta/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___vi",
    path: "/vi/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___kk",
    path: "/kk/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___it",
    path: "/it/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___nl",
    path: "/nl/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___he",
    path: "/he/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___ko",
    path: "/ko/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___pt",
    path: "/pt/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___th",
    path: "/th/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___uk",
    path: "/uk/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___pl",
    path: "/pl/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___ro",
    path: "/ro/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "continue-booking___hi",
    path: "/hi/continue-booking/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/continue-booking.vue")
  },
  {
    name: "debugAuth___en___default",
    path: "/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___en",
    path: "/en/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___ru",
    path: "/ru/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___tr",
    path: "/tr/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___de",
    path: "/de/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___fr",
    path: "/fr/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___es",
    path: "/es/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___xx",
    path: "/xx/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___ar",
    path: "/ar/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___zh",
    path: "/zh/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___ta",
    path: "/ta/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___vi",
    path: "/vi/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___kk",
    path: "/kk/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___it",
    path: "/it/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___nl",
    path: "/nl/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___he",
    path: "/he/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___ko",
    path: "/ko/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___pt",
    path: "/pt/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___th",
    path: "/th/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___uk",
    path: "/uk/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___pl",
    path: "/pl/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___ro",
    path: "/ro/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "debugAuth___hi",
    path: "/hi/debugAuth/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/debugAuth.vue")
  },
  {
    name: "hotel-hotelSlug___en___default",
    path: "/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___en",
    path: "/en/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___ru",
    path: "/ru/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___tr",
    path: "/tr/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___de",
    path: "/de/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___fr",
    path: "/fr/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___es",
    path: "/es/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___xx",
    path: "/xx/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___ar",
    path: "/ar/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___zh",
    path: "/zh/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___ta",
    path: "/ta/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___vi",
    path: "/vi/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___kk",
    path: "/kk/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___it",
    path: "/it/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___nl",
    path: "/nl/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___he",
    path: "/he/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___ko",
    path: "/ko/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___pt",
    path: "/pt/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___th",
    path: "/th/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___uk",
    path: "/uk/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___pl",
    path: "/pl/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___ro",
    path: "/ro/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug___hi",
    path: "/hi/hotel/:hotelSlug()/",
    meta: indexY4QFcRAMwqMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/index.vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___en___default",
    path: "/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___en",
    path: "/en/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___ru",
    path: "/ru/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___tr",
    path: "/tr/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___de",
    path: "/de/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___fr",
    path: "/fr/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___es",
    path: "/es/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___xx",
    path: "/xx/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___ar",
    path: "/ar/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___zh",
    path: "/zh/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___ta",
    path: "/ta/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___vi",
    path: "/vi/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___kk",
    path: "/kk/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___it",
    path: "/it/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___nl",
    path: "/nl/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___he",
    path: "/he/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___ko",
    path: "/ko/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___pt",
    path: "/pt/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___th",
    path: "/th/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___uk",
    path: "/uk/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___pl",
    path: "/pl/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___ro",
    path: "/ro/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "hotel-hotelSlug-offer-offerSlug___hi",
    path: "/hi/hotel/:hotelSlug()/offer/:offerSlug()/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/hotel/[hotelSlug]/offer/[offerSlug].vue")
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___xx",
    path: "/xx/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___ta",
    path: "/ta/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___kk",
    path: "/kk/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/index.vue")
  },
  {
    name: "legal-page-slug___en___default",
    path: "/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___en",
    path: "/en/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___ru",
    path: "/ru/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___tr",
    path: "/tr/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___de",
    path: "/de/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___fr",
    path: "/fr/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___es",
    path: "/es/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___xx",
    path: "/xx/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___ar",
    path: "/ar/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___zh",
    path: "/zh/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___ta",
    path: "/ta/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___vi",
    path: "/vi/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___kk",
    path: "/kk/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___it",
    path: "/it/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___nl",
    path: "/nl/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___he",
    path: "/he/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___ko",
    path: "/ko/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___pt",
    path: "/pt/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___th",
    path: "/th/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___uk",
    path: "/uk/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___pl",
    path: "/pl/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___ro",
    path: "/ro/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "legal-page-slug___hi",
    path: "/hi/legal-page/:slug()/",
    meta: _91slug_93IAASyQZ68gMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/legal-page/[slug].vue")
  },
  {
    name: "maintenance___en___default",
    path: "/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ru",
    path: "/ru/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___tr",
    path: "/tr/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___de",
    path: "/de/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___fr",
    path: "/fr/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___es",
    path: "/es/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___xx",
    path: "/xx/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ar",
    path: "/ar/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___zh",
    path: "/zh/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ta",
    path: "/ta/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___vi",
    path: "/vi/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___kk",
    path: "/kk/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___it",
    path: "/it/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___nl",
    path: "/nl/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___he",
    path: "/he/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ko",
    path: "/ko/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___pt",
    path: "/pt/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___th",
    path: "/th/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___uk",
    path: "/uk/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___pl",
    path: "/pl/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ro",
    path: "/ro/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "maintenance___hi",
    path: "/hi/maintenance/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/maintenance.vue")
  },
  {
    name: "other-page-slug___en___default",
    path: "/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___en",
    path: "/en/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___ru",
    path: "/ru/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___tr",
    path: "/tr/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___de",
    path: "/de/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___fr",
    path: "/fr/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___es",
    path: "/es/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___xx",
    path: "/xx/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___ar",
    path: "/ar/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___zh",
    path: "/zh/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___ta",
    path: "/ta/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___vi",
    path: "/vi/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___kk",
    path: "/kk/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___it",
    path: "/it/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___nl",
    path: "/nl/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___he",
    path: "/he/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___ko",
    path: "/ko/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___pt",
    path: "/pt/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___th",
    path: "/th/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___uk",
    path: "/uk/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___pl",
    path: "/pl/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___ro",
    path: "/ro/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "other-page-slug___hi",
    path: "/hi/other-page/:slug()/",
    meta: _91slug_935yhvTgs9KDMeta || {},
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/other-page/[slug].vue")
  },
  {
    name: "search___en___default",
    path: "/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___ru",
    path: "/ru/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___tr",
    path: "/tr/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___es",
    path: "/es/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___xx",
    path: "/xx/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___ar",
    path: "/ar/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___zh",
    path: "/zh/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___ta",
    path: "/ta/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___vi",
    path: "/vi/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___kk",
    path: "/kk/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___he",
    path: "/he/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___ko",
    path: "/ko/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___pt",
    path: "/pt/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___th",
    path: "/th/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___uk",
    path: "/uk/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___pl",
    path: "/pl/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___ro",
    path: "/ro/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  },
  {
    name: "search___hi",
    path: "/hi/search/",
    component: () => import("/usr/src/app/packages/all-inclusive-app/pages/search.vue")
  }
]